import moment from "moment";
import jwt_decode from "jwt-decode";
import 'moment/locale/fr';

import { createContext, useContext } from "react";
import { login as signinApi } from "./api/Auth";
import { refresh as refreshTokenApi } from "./api/Auth";

/** For more details on
 * `authContext`, `ProvideAuth`, `useAuth` and `useProvideAuth`
 * refer to: https://usehooks.com/useAuth/
 */
const authContext = createContext();

export function ProvideAuth({ children }) {
  const auth = useProvideAuth();
  return <authContext.Provider value={auth}>{children}</authContext.Provider>;
}

export function useAuth() {
  return useContext(authContext);
}

export function useProvideAuth() {
  let timeOutRefresh = null;

  const signin = (payload, resolved, rejected) => {
    clearTimeout(timeOutRefresh);
    return signinApi(payload)
      .then((response) => {
        if (!response.ok) throw Error();
        return response.json();
      })
      .then(async data => {
        localStorage.setItem("refresh_token", data.refresh_token);
        await authenticate(data.access_token);
        resolved();
      })
      .catch(() => {
        rejected();
      });
  };

  const signout = (cb) => {
    clearTimeout(timeOutRefresh);
    localStorage.removeItem('token_auth');
    localStorage.removeItem('refresh_token');

    cb();
  };

  const authenticate = (access_token) => {
    clearTimeout(timeOutRefresh);
    localStorage.setItem("token_auth", access_token);

    let decode_token = jwt_decode(access_token);
    let exp = moment.unix(decode_token['exp']);
    // 20% du delta entre now et l'exp (x0.8)
    let deltaMiliSec = ((exp.unix() - moment().unix()) * 1000) * 0.8;

    timeOutRefresh = setTimeout(() => {
      refreshAccessToken()
        .catch(() => {
          signout(() => {});
        });
    }, deltaMiliSec);
  };

  const isExpired = () => {
    const token_auth = localStorage.getItem("token_auth");

    try {
        const decode_token = jwt_decode(token_auth);
        let delta = decode_token['exp'] - decode_token["iat"];
        let exp = moment.unix(decode_token["iat"] + delta);

        if (exp < moment() ) {
            return true;
        }
    } catch (err) { }

    return false;
  };

  const refreshAccessToken = () => {
    return refreshTokenApi()
      .then((response) => {
        if (!response.ok) throw Error();
        return response.json();
      })
      .then( async data => {
        await authenticate(data.access_token);
        return data;
      });
  };

  return {
    signin,
    signout,
    isExpired,
    refreshAccessToken,
  };
}
